import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.users.generate-login-code', {
        url: '/:groupId/generate-login-code',
        params: {groupId: null},
        views: {
            '@company.manage-application': 'companyManageApplicationUsersGenerateLoginCode'
        },
		resolve: {
			groupId,
        },
    });
}

/** @ngInject */
function groupId($stateParams) {
    return $stateParams.groupId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/generate-login-code/generate-login-code.state.js